import { db } from './firebase';
import { collection, onSnapshot } from 'firebase/firestore';
import type { BadgeDefinition, DadProfile } from '../types';
import { getBadgesMasterList } from './badgeService';

import { syncCurrentProfileWithDoc } from './authService';

type UsersListener = (users: DadProfile[]) => void;
const listeners: UsersListener[] = [];
let usersCache: DadProfile[] = [];

export function subscribeUsers(listener: UsersListener): () => void {
  listeners.push(listener);
  listener(usersCache);

  const colRef = collection(db, 'users');
  const unsub = onSnapshot(colRef, (snapshot) => {
    const items: DadProfile[] = [];
    snapshot.forEach(d => {
      const data = d.data();
      const profile: DadProfile = {
        uid: d.id,
        ...data,
        crew: data.crew || [],
        crewRequestsSent: data.crewRequestsSent || [],
        crewRequestsReceived: data.crewRequestsReceived || []
      } as DadProfile;
      items.push(profile);
      syncCurrentProfileWithDoc(profile);
    });
    usersCache = items;
    listeners.forEach(fn => fn(usersCache));
  }, (err) => {
    console.warn('[Pops Culture] Firestore users snapshot warning:', err);
  });

  return () => {
    unsub();
    const idx = listeners.indexOf(listener);
    if (idx !== -1) listeners.splice(idx, 1);
  };
}

export function getRegisteredUsers(): DadProfile[] {
  return usersCache;
}

export { getBadgesMasterList } from './badgeService';

